import type { ExerciseInfo } from '@az3fr/core';

import type { UseEntitySelectionDialogOptions } from '@/hooks/use-entity-selection-dialog';
import { useEntitySelectionDialog } from '@/hooks/use-entity-selection-dialog';

/**
 * Convenience hook for exercise selection dialogs.
 * A typed wrapper around useEntitySelectionDialog specifically for exercises.
 *
 * For optimal performance, wrap your callbacks in useCallback:
 *
 * const handleExercises = useCallback((exercises) => { ... }, [deps]);
 * const dialog = useExerciseDialog({ onExercisesSelected: handleExercises });
 */
function useExerciseDialog({
	onExercisesSelected,
	options,
}: {
	onExercisesSelected: (exercises: ExerciseInfo[]) => void;
	options?: Omit<UseEntitySelectionDialogOptions<ExerciseInfo>, 'onEntitiesSelected'>;
}) {
	return useEntitySelectionDialog<ExerciseInfo>({
		...options,
		onEntitiesSelected: onExercisesSelected,
	});
}

export { useExerciseDialog };
